import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnDestroy } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService, UtilsService, CheckboxComponent} from 'shared-components';
import { EtiquetadoContextService } from "../../context/etiquetado-context.service";
import { EtiquetadoService } from "../../services/etiquetado.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Router } from '@angular/router';
@Component({
    selector: 'app-mantenimiento-etiquetadores',
    templateUrl: './mantenimiento-etiquetadores.component.html'
})
export class MantenimientoEtiquetadoresComponent implements OnInit, OnDestroy {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;
    private _filters;
    public filtersVisible = false;
    public filtersForm: UntypedFormGroup;

    public dropdownInfo: number;
    public dropdownSection: number;

    public refreshCheckbox_impAutorizada = false;
    public refreshCheckbox_reimpAutorizada = false;

    public etiquetadores;
    public etiquetadorId;
    public denominaciones;

    public disabledDenominaciones: Subject<boolean> = new Subject();

    public mensajes = new Array<Message>();
    public showError: boolean;

    public deleteModal = false;
    public newEditModal = false;

    public pestanaActiva = new Array<number>();

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public toCloseSpinner = 0;

    public exportModal = 0;

    public orderBy = 'asc';
    public columnNumber;
    public columnName: string;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private readonly _router: Router,
        private _fb: UntypedFormBuilder,
        private _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _etiquetadoContext: EtiquetadoContextService,
        private readonly _dataProvider: DataProvider,
        public readonly utilsService: UtilsService,
        private readonly _translate: TranslateService
    ) {}

    ngOnInit() {
        this.filtersForm = this._fb.group({
            denominacion: [{value: '', disabled: true}],
            pais: [''],
            des: [''],
            impAutorizada: [''],
            reimpAutorizada: [''],
            fechaInicio: [''],
            fechaFin: [''],
            dateType: ['false'],
        });

        this.applyFilters();

        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());

        this.filtersForm.get('pais').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
            if (pais) {
                const filters = {
                    paisId: pais.id
                };
                this.filtersForm.get('denominacion').enable({ emitEvent: false });
                this.filtersForm.get('denominacion').patchValue('');
                this._spinnerService.showSpinner();
                this._etiquetadoService.getDenominaciones(filters).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then((resp) => {
                    this.denominaciones = resp.lista;
                    if (this.denominaciones.length === 1) {
                        this.filtersForm.get('denominacion').patchValue(this.denominaciones[0]);
                        this.filtersForm.get('denominacion').disable();
                        this.disabledDenominaciones.next(true);
                    } else {
                        this.filtersForm.get('denominacion').enable();
                        this.disabledDenominaciones.next(false);
                    }
                });
            } else {
                this.filtersForm.get('denominacion').disable({ emitEvent: false });
                this.filtersForm.get('denominacion').patchValue('');
                this.disabledDenominaciones.next(true);
                this.denominaciones = null;
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get paises() {
        if (this._dataProvider.paises) {
            if (this._dataProvider.paises.length === 1 && this.filtersForm.get('pais').enabled) {
              this.filtersForm.get('pais').patchValue(this._dataProvider.paises[0]);
              this.filtersForm.get('pais').disable();
            }
          }
        return this._dataProvider.paises;
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public get defaultLanguage() {
      return this._translate.getDefaultLang();
    }

    public get isSmallScreen(){
      return this._sessionContext.isSmallScreen();
    }

    public pageChange(page) {
        this.dropdownInfo = -1;
        this.dropdownSection = -1;
        this._etiquetadoContext.mantenimientoEtiquetadoresFilters.numPagina = this.currentPage = page - 1;
        this.getEtiquetadores();
    }

    public itemsPerPageChange(items) {
        this.dropdownInfo = -1;
        this.dropdownSection = -1;
        this._etiquetadoContext.mantenimientoEtiquetadoresFilters.numPagina = this.currentPage = 0;
        this._etiquetadoContext.mantenimientoEtiquetadoresFilters.tamPagina = this.itemsPerPage = items;
        this.getEtiquetadores();
    }

    private clearDatesValidators() {
        if (this.filtersForm.get('fechaFin').errors && this.filtersForm.get('fechaFin').value) {
            this.filtersForm.get('fechaFin').clearValidators();
            this.filtersForm.get('fechaFin').updateValueAndValidity();
        }
        if (this.filtersForm.get('fechaInicio').errors && this.filtersForm.get('fechaInicio').value) {
            this.filtersForm.get('fechaInicio').clearValidators();
            this.filtersForm.get('fechaInicio').updateValueAndValidity();
        }
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    public validDates() {
        if (this.filtersForm.get('fechaInicio').value && this.filtersForm.get('fechaFin').value) {
            if (this.checkDates(this.filtersForm.get('fechaInicio').value, this.filtersForm.get('fechaFin').value)) {
                this.clearDatesValidators();
            } else {
                this.filtersForm.get('fechaInicio').setErrors(['Invalid date']);
                this.filtersForm.get('fechaFin').setErrors(['Invalid date']);
            }
            if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid) {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio'});
            } else {
                this.showError = false;
                this.mensajes = [];
            }
        } else {
            this.clearDatesValidators();
            this.showError = false;
            this.mensajes = [];
        }
    }

    public checkValuesForm(): boolean {
        return (
            (this.filtersForm.get('denominacion').value && this.filtersForm.get('denominacion').enabled ) ||
            (this.filtersForm.get('pais').value && this.filtersForm.get('pais').enabled) ||
            this.filtersForm.get('des').value ||
            !this.filtersForm.get('impAutorizada').pristine ||
            !this.filtersForm.get('reimpAutorizada').pristine ||
            this.filtersForm.get('fechaInicio').value ||
            this.filtersForm.get('fechaFin').value) ? true : false;
    }

    public resetForm() {
        this.filtersForm.reset({
            pais: this.filtersForm.get('pais').disabled ? this.filtersForm.get('pais').value : null,
            denominacion: this.filtersForm.get('denominacion').disabled ? this.filtersForm.get('denominacion').value : null,
            dateType: 'false'
        });
        // this.filtersForm.get('dateType').patchValue('false');
        this.refreshCheckbox_impAutorizada = true;
        this.refreshCheckbox_reimpAutorizada = true;
    }

    public pristineCheckbox(idForm:string, pristine:boolean){
      const form = this.filtersForm.get(idForm);
      pristine ? form.markAsPristine() : form.markAsDirty();
    }

    public filtrar() {
        this.validDates();
        
        if (this.filtersForm.valid) {
            this.applyFilters();
        }
    }

    private applyFilters() {
        this.columnNumber = 0; // "Reseteamos" los iconos de las flechas
        this.currentPage = 0;
        this._etiquetadoContext.mantenimientoEtiquetadoresFilters = {
            denominacionId: this.filtersForm.get('denominacion').value ? this.filtersForm.get('denominacion').value.id : '',
            paisId: this.filtersForm.get('pais').value ? this.filtersForm.get('pais').value.id : '',
            desEtiquetador: this.filtersForm.get('des').value ? this.filtersForm.get('des').value : '',
            impresionAutorizada: this.filtersForm.get('impAutorizada').value ? this.filtersForm.get('impAutorizada').value : '',
            reimpresionAutorizada: this.filtersForm.get('reimpAutorizada').value ? this.filtersForm.get('reimpAutorizada').value : '',
            cargaRegistroEnUso: true,
            cargaMarcasAsociadas: true,
            fechaInicio: this.filtersForm.get('fechaInicio').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
            fechaFin: this.filtersForm.get('fechaFin').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
            fechaActualizacion: this.filtersForm.get('dateType').value ? this.filtersForm.get('dateType').value : false,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };

        this.getEtiquetadores();
    }

    public getEtiquetadores() {
        if (this._etiquetadoContext.mantenimientoEtiquetadoresFilters) {
            this._filters = this._etiquetadoContext.mantenimientoEtiquetadoresFilters;
        } else {
            this.applyFilters();
        }
        this._spinnerService.showSpinner();
        this._etiquetadoService.getEtiquetadores(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.etiquetadores = resp.lista;
        }, (error) => {
            this.pushMessage('global.error.noResponse');
        });
    }

    public export(type) {
        this.exportReport(type);
        this.exportModal = 0;
    }

    private downloadPdf() {
        this.toCloseSpinner += 1;
        this._etiquetadoService.getReportEtiquetadoresPdf(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then(
            (resp) => {
                const downloadLink = document.createElement('a');
                downloadLink.href = 'data:application/pdf;base64,' + resp.base64Archivo;
                downloadLink.download = resp.nombreArchivo;
                downloadLink.click();
            },
            (error) => {
                this.pushMessage('global.error.file');
            });
    }

    private downloadCsv() {
        this.toCloseSpinner += 1;
        this._etiquetadoService.getReportEtiquetadoresCsv(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then(
            (resp) => {
                const downloadLink = document.createElement('a');
                downloadLink.href = 'data:text/csv;base64,' + resp.base64Archivo;
                downloadLink.download = resp.nombreArchivo;
                downloadLink.click();
            },
            (error) => {
                this.pushMessage('global.error.file');
            });
    }

    public exportReport(type: number) {
        if (this.etiquetadores && this.etiquetadores.length > 0) {
            if (this._etiquetadoContext.mantenimientoEtiquetadoresFilters) {
                this._filters = this._etiquetadoContext.mantenimientoEtiquetadoresFilters;
                this._filters.tamPagina = 0;
                this._filters.tipoArchivo = this.exportModal === 1 ? 'Pdf' : 'Csv';
                this._filters.mostrarDetalle = type === 1 ? false : true;
            }
            this._spinnerService.showSpinner();
            this.exportModal === 1 ? this.downloadPdf() : this.downloadCsv();
        } else {
            this.pushMessage('global.error.exportNoData');
        }
    }

    public create() {
        this.etiquetadorId = null;
        this.newEditModal = true;
    }

    public update(etiquetador) {
        this.etiquetadorId = etiquetador.id;
        this.newEditModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._etiquetadoService.deleteEtiquetador(this.etiquetadorId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');
            this.getEtiquetadores();
        });
    }

    public askDelete(etiquetador) {
        this.etiquetadorId = etiquetador.id;
        this.deleteModal = true;
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
    }

    public refresh(value) {
        this.newEditModal = false;
        if (value) {
            this.getEtiquetadores();
        }
    }

    public change($event) {
        if ($event) {
            this.refreshCheckbox_impAutorizada = false;
            this.refreshCheckbox_reimpAutorizada = false;
        }
    }

    public pushMessage(mensaje) {
        this.showError = true;
        if (mensaje.includes('req') || mensaje.includes('ya') || mensaje.includes('ApiErrors') || mensaje.includes('error')) {
            this.mensajes.push({ class: 'error', message: mensaje});
        } else {
            this.mensajes.push({ class: 'success', message: mensaje});
        }
    }

    public showDetails(i: number) {
        if (this.role !== 'Supervisor') {
            this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
            if (this.dropdownInfo !== -1 && window.innerWidth <= 1199) {
                setTimeout(() => {
                    document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
                }, 50);
            }
        }
    }

    public showSection(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
        this.pestanaActiva[i] = this.pestanaActiva[i] > 0 ? this.pestanaActiva[i] : 1;
        // Desplazamiento a la izquierda para tablet (mismo tamaño máx. que en table.scss)
        if (this.dropdownSection !== -1 && window.innerWidth <= 1199) {
            // Retardo en caso de que haya otro detalle abierto
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public showDenominaciones(i) {
        this.pestanaActiva[i] = 1;
    }

    public showAlmacenes(i) {
        this.pestanaActiva[i] = 2;
    }

    public showReetiquetadores(i) {
        this.pestanaActiva[i] = 3;
    }

    private checkCloseSpinner() {
      this.toCloseSpinner -= 1;
      if (this.toCloseSpinner === 0) {
          this._spinnerService.hideSpinner();
      }
    }

    public openDocHelp() {
      this._spinnerService.showSpinner();
      this.toCloseSpinner += 1;
      this._etiquetadoService.getDocHelp('Labeling_Packers.pdf').toPromise().finally(() => {
          this.checkCloseSpinner();
      }).then((resp) => {
          localStorage.setItem('base64', resp.base64Archivo);
          const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
          window.open(url, '_blank');
      });
    }

    public toOrderBy(colNumber: number, colData: string) {
        this.columnNumber = colNumber;
        this.columnName = colData;
        this.orderBy = this.orderBy === 'asc' ? 'desc' : 'asc';
        this._filters.orderItems = [
            {
                orderProperty: this.columnName,
                orderByDescending: this.orderBy === 'desc' ? true : false
            }
        ]
        this.getEtiquetadores();
    }

    public getIcon(colNumber: number) {
        let iconClass = 'fa fa-sort';
        if (colNumber === this.columnNumber) {
            iconClass = this.orderBy === 'desc' ? 'fa fa-sort-down' : 'fa fa-sort-up';
        }
        return iconClass;
    }

    public trackByEtiquetadorId(index: number, etiquetador: { id: number }): number {
        return etiquetador.id;
    }
}
